/**
 * UsersManageAdminPage
 *
 * Admin page for searching users and managing an account from its opened row
 * (account kind, Affiliate Portal access, coupons).
 * Create-affiliate lives on AffiliatesAdminPage.
 */

import React from "react";
import { textColors, typography } from "../../design-system/tokens";
import AdminAffiliateUsersPanel from "../components/AdminAffiliateUsersPanel";

const UsersManageAdminPage = () => {
  return (
    <div className="p-4 sm:p-6">
      <div className="max-w-7xl mx-auto space-y-6">
        <div>
          <h1 className={`${typography.h2} ${textColors.primary}`}>Users</h1>
          <p className={`${typography.body} ${textColors.secondary} mt-1`}>
            Search users and open a row to change its account kind, manage Affiliate Portal access, and
            review coupons.
          </p>
        </div>

        <AdminAffiliateUsersPanel />
      </div>
    </div>
  );
};

export default UsersManageAdminPage;
